// extracted by mini-css-extract-plugin
module.exports = {"notifyPopoverHead":"notifyPopoverHead--kLLA4","notifyPopoverHeadBtn":"notifyPopoverHeadBtn--uJujP"};